

































































































import { container } from "@/inversify.config";
import { BarcodeOperationModel } from "fs-pb-vue2/models/operations/BarcodeOperationModel";
import { DiTokens } from "fs-pb-vue2/services/diTokens";
import BarcodeOperationService from "fs-pb-vue2/services/operations/BarcodeOperationService";
import IOperationService from "fs-pb-vue2/services/operations/IOperationService";
import { SliderVue } from "fs-pb-vue2/vueModels/app/SliderVue";
import { Component } from "vue-property-decorator";

@Component({ components: {} })
export default class QuiqOperations extends SliderVue {
    /**
 * Список слайдов
 * @returns {Array<any>} - массив объектов.
 */
  get slides(): Array<any> {
    return this.configStore.quiqOperations;
  }
  
  async onDetect(content: any): Promise<void> {
    this.qrPaused = true;
    if (!content) {
      console.log(content);
      this.toggleQR();
      return;
    } 
    this.qrLoading = true;
    let operationModel: BarcodeOperationModel = (await this.service.init( 
      content
    )) as BarcodeOperationModel;
    operationModel = await (this.service as BarcodeOperationService).execute(operationModel) as BarcodeOperationModel
    this.toggleQR();
    this.$router.push(operationModel.urlString)
    this.qrLoading = false;
  }

  service: IOperationService = container.get<IOperationService>(
    DiTokens.BarcodeOperationService
  );  

  sliderPos: number = 0;

  isQrOpen: boolean = false;

  qrPaused: boolean = false;

  qrLoading: boolean = false;

  formats: Array<string> = [
    'aztec',
    'code_128',
    'code_39',
    'code_93',
    'codabar',
    'databar',
    'databar_expanded',
    'data_matrix',
    'dx_film_edge',
    'ean_13',
    'ean_8',
    'itf',
    'maxi_code',
    'micro_qr_code',
    'pdf417',
    'qr_code',
    'rm_qr_code',
    'upc_a',
    'upc_e',
    'linear_codes',
    'matrix_codes'
  ];

  goToSBP(): void {
    if (this.configStore && this.configStore.apiData && this.configStore.apiData.OperationCodeOfSbpOperation) {
      this.$router.push(`operation/0/${this.configStore.apiData.OperationCodeOfSbpOperation}`)
    }
  }

  step(flag: boolean): void {
    const length: number = this.slides.length;
    const maxStep: number = Math.round(length / 4) + 1;
    if (flag && this.sliderPos < maxStep) {
      this.sliderPos++;
    } else if (!flag && this.sliderPos > 0) {
      this.sliderPos--;
    }
  }

  redirectToOperation(p) {
    const url = `/operation/0/${p.CatalogId}`;
    this.$router.push(url);
  }

  toggleQR(): void {
    if (this.qrPaused && !this.isQrOpen)
      this.qrPaused = false;
    else if (!this.qrPaused && this.isQrOpen)
      this.qrPaused = true;
    this.isQrOpen = !this.isQrOpen;
  }

  created() {
    window.addEventListener("resize", this.updateWidth);
  }
  mounted() {
    this.updateWidth();
  }
}
